import script from "./RecordedPreviousSessionDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordedPreviousSessionDetails.vue?vue&type=script&setup=true&lang=js"

import "./RecordedPreviousSessionDetails.vue?vue&type=style&index=0&id=0544dfb4&scoped=true&lang=css"
import "./RecordedPreviousSessionDetails.vue?vue&type=style&index=1&id=0544dfb4&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0544dfb4"]])

export default __exports__